/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Nexy_Feature_1_TitleInputs */

const es_home_nexy_feature_1_title = /** @type {(inputs: Home_Nexy_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Búsqueda Semántica`)
};

const en_home_nexy_feature_1_title = /** @type {(inputs: Home_Nexy_Feature_1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semantic Search`)
};

/**
* | output |
* | --- |
* | "Semantic Search" |
*
* @param {Home_Nexy_Feature_1_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const home_nexy_feature_1_title = /** @type {((inputs?: Home_Nexy_Feature_1_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Nexy_Feature_1_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_nexy_feature_1_title(inputs)
	return en_home_nexy_feature_1_title(inputs)
});
export { home_nexy_feature_1_title as "home.nexy.feature_1_title" }